
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import format from 'date-fns/format';
import cloneDeep from 'lodash/cloneDeep';
import PropTypes from 'prop-types';

import {
    Card,
    CardHeader,
    CardSection,
    Flex,
    FormHelp,
    Paragraph,
    Spacer,
    TextButton,
} from '@zillow/constellation';

import { PropertiesSelectors } from 'app/shared/selectors';
import ModalActions from 'app/shared/actions/ModalActions';
import ModalConstants from 'app/shared/constants/ModalConstants';
import PropertiesActions from 'app/shared/actions/PropertiesActions';

import { StyledInlineSpacer, StyledBorderTopSpacer } from './StyledComponents';

const propTypes = {
    index: PropTypes.number.isRequired,
    offerToDisplay: PropTypes.shape({
        startDateYyyyMmDd: PropTypes.string,
        endDateYyyyMmDd: PropTypes.string,
        description: PropTypes.string,
        offerIdEncoded: PropTypes.string,
    }).isRequired,
    specialOffers: PropTypes.array.isRequired,
    updateFormData: PropTypes.func.isRequired,
};

const SavedSpecialOfferCard = ({
    index,
    offerToDisplay,
    specialOffers,
    updateFormData,
}) => {
    const dispatch = useDispatch();
    const [error, setError] = useState();
    const { listingAlias } = useSelector(state => PropertiesSelectors.makeCurrentProperty(state));

    const {
        startDateYyyyMmDd: startDate,
        endDateYyyyMmDd: endDate,
        description,
        offerIdEncoded,
    } = offerToDisplay;

    const formattedStartDate = startDate ? format(new Date(`${startDate}T10:00:00`), 'MM/DD/YYYY') : ' - ';
    const formattedEndDate = endDate ? format(new Date(`${endDate}T10:00:00`), 'MM/DD/YYYY') : ' - ';

    const onDelete = () => {
        dispatch(PropertiesActions.deleteSpecialOffer({
            listingId: listingAlias,
            offerIdEncoded,
        }))
            .then((response) => {
                if (response) {
                    const copySpecialOffers = cloneDeep(specialOffers);
                    copySpecialOffers.splice(index, 1);
                    updateFormData({ specialOffers: copySpecialOffers });
                }
            })
            .catch((errorRMWModel) => {
                setError(errorRMWModel.message);
            });
    };

    const onEdit = () => {
        dispatch(ModalActions.showModal({
            modalType: ModalConstants.ADD_SPECIAL_OFFER_MODAL,
            header: 'Edit special offer',
            updateFormData,
            defaultOffer: offerToDisplay,
            specialOffers,
            action: 'edit',
            isFluid: true,
        }));
    };

    return (
        <Spacer marginY="xs">
            <Card>
                <CardHeader>
                    <StyledInlineSpacer marginRight="sm">
                        {`Start date: ${formattedStartDate}`}
                    </StyledInlineSpacer>
                    {`End date: ${formattedEndDate}`}
                </CardHeader>
                <CardSection>
                    <Paragraph>{description}</Paragraph>
                    {error && <FormHelp error={true}>{error}</FormHelp>}
                </CardSection>
                <StyledBorderTopSpacer>
                    <Flex display="flex" justifyContent="flex-start">
                        <Spacer marginRight="sm">
                            <TextButton onClick={onEdit}>Edit</TextButton>
                        </Spacer>
                        <TextButton onClick={onDelete} disabled={!offerIdEncoded}>Delete</TextButton>
                    </Flex>
                </StyledBorderTopSpacer>
            </Card>
        </Spacer>
    );
};

SavedSpecialOfferCard.propTypes = propTypes;

export default SavedSpecialOfferCard;
